import {Constant} from "../../constant";
import React from "react";


export default function CommonFormErrorText({text}){
    return <span style={{color: "red", fontSize:12, paddingLeft:10}}>
                {Constant.champObligatoire}
                {text ? 'et '+text : ''}
            </span>
}